module ScriptMetaData {
    export function Init() {
        const idScript = $('#hdnIdScript').val() as string;

        const dataTableSettings: DataTables.Settings = {
            serverSide: true,
            processing: true,
            pageLength: 25,
            scrollY: '55vh',
            ajax: {
                url: `/ScriptMetaData/ListData/${idScript}`,
                type: 'GET'
            }
        };

        var columnDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: 6,
                className: "text-wrap",
                createdCell: function (td) {
                    $(td).css({
                        "white-space": "normal",
                        "word-break": "break-all",
                        "overflow-wrap": "anywhere"
                    });
                }
            },
            {
                targets: 7,
                width: '40px',
                className: 'spc-td-actions',
                orderable: false,
                render: function (data) {
                    return `<div class='spc-actions-wrap'><a class='spc-table-action script-metadata-details' data-id-script='${data}' title='Detalji'><i class='fas fa-info-circle spc-action-icon spc-action-icon--info'></i></a></div>`;
                }
            },
            {
                targets: 8,
                width: '40px',
                className: 'spc-td-actions',
                orderable: false,
                render: function (data) {
                    if (!data || !data.metaName) return '';
                    const encoded = encodeURIComponent(JSON.stringify(data));
                    return `<div class='spc-actions-wrap'><a class='spc-table-action script-metadata-timeline' data-timeline='${encoded}' title='Timeline'><i class='fas fa-history spc-action-icon' style='color:#7C3AED;'></i></a></div>`;
                }
            }
        ];

        Common.DataTableCustom.Init(
            "metaDataTable",
            dataTableSettings,
            columnDef,
            `/ScriptMetaData/ListData/${idScript}`
        );

        $('#metaDataTable').on('click', '.script-metadata-details', function () {
            const scriptId = $(this).data("id-script");
            Dialog.OpenDetailsModal('Detalji skripte', '/Script/Details/' + scriptId);
        });

        $('#metaDataTable').on('click', '.script-metadata-diff', function () {
            const idMetaData = $(this).data("id-meta-data");
            Dialog.OpenModal('<i class="fas fa-exchange-alt" style="margin-right:6px;color:#378ADD;"></i>Razlike skripte', '', `/ScriptMetaData/DiffDetail/${idMetaData}`);
        });

        $('#metaDataTable').on('click', '.script-metadata-timeline', function () {
            const raw = decodeURIComponent($(this).data("timeline") as string);
            const info = JSON.parse(raw);
            if (typeof (window as any).openTimeline === 'function') {
                const openedScriptIdFromRow = parseInt(info.idScript, 10);
                const openedScriptIdFromPage = parseInt(idScript, 10);
                const openedScriptId = !isNaN(openedScriptIdFromRow)
                    ? openedScriptIdFromRow
                    : (isNaN(openedScriptIdFromPage) ? null : openedScriptIdFromPage);
                (window as any).openTimeline(info.metaName, info.metaType, info.metaUser, isNaN(openedScriptId) ? null : openedScriptId);
                $('#TimelineModal').modal('show');
            }
        });

    }

    export function RefreshAllDiffs() {
        const conn = (window as any).connection;
        const connectionId: string = conn && conn.connectionId ? conn.connectionId : '';
        let totalItems = 0;
        let doneCount = 0;

        function showOverlay() { $('#diffProgressOverlay').removeClass('d-none'); }

        function hideOverlay() {
            $('#diffProgressOverlay').addClass('d-none');
            $('#diffProgCurrent').text('0');
            $('#diffProgTotal').text('0');
            $('#diffProgBar').css('width', '0%');
            $('#diffProgCurrentName').text('—');
            $('#diffProgDone').text('0');
            $('#diffProgRunning').text('0');
            $('#diffProgPending').text('0');
            $('#diffProgList').empty();
        }

        function buildList(items: Array<{ name: string, type: string }>) {
            const $list = $('#diffProgList').empty();
            items.forEach((item, i) => {
                $list.append(
                    `<div class="diff-progress-item" id="diffProgItem_${i}">` +
                    `<span class="diff-progress-item__icon"><i class="far fa-circle" style="color:#d0d5dd;"></i></span>` +
                    `<span class="diff-progress-item__type">${item.type}</span>` +
                    `<span class="diff-progress-item__name">${item.name}</span>` +
                    `</div>`
                );
            });
        }

        function updateItemStatus(index: number, status: 'running' | 'done') {
            const $item = $(`#diffProgItem_${index}`);
            $item.removeClass('diff-progress-item--running diff-progress-item--done');
            if (status === 'running') {
                $item.addClass('diff-progress-item--running');
                $item.find('.diff-progress-item__icon').html('<i class="fas fa-spinner fa-spin" style="color:#378ADD;"></i>');
                const el = $item[0];
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } else {
                $item.addClass('diff-progress-item--done');
                $item.find('.diff-progress-item__icon').html('<i class="fas fa-check-circle" style="color:#12b76a;"></i>');
            }
        }

        const progressHandler = (data: any) => {
            if (data.phase === 'init') {
                totalItems = data.total;
                doneCount = 0;
                $('#diffProgTotal').text(totalItems);
                $('#diffProgPending').text(totalItems);
                $('#diffProgCurrent').text('0');
                buildList(data.items);
                showOverlay();
            } else if (data.phase === 'start') {
                updateItemStatus(data.index, 'running');
                const $item = $(`#diffProgItem_${data.index}`);
                const name = $item.find('.diff-progress-item__name').text();
                const type = $item.find('.diff-progress-item__type').text();
                $('#diffProgCurrentName').text(`${type}: ${name}`);
                $('#diffProgRunning').text('1');
                $('#diffProgPending').text(Math.max(0, totalItems - data.index - 1));
            } else if (data.phase === 'done') {
                updateItemStatus(data.index, 'done');
                doneCount++;
                $('#diffProgCurrent').text(doneCount);
                $('#diffProgDone').text(doneCount);
                $('#diffProgRunning').text('0');
                const pct = totalItems > 0 ? Math.round(doneCount / totalItems * 100) : 0;
                $('#diffProgBar').css('width', pct + '%');
            } else if (data.phase === 'complete') {
                $('#diffProgCurrentName').text('Završeno!');
                $('#diffProgBar').css('width', '100%');
                setTimeout(() => {
                    hideOverlay();
                    Notifications.GetNotification(`Osvježeno ${data.updated} objekata`, 'success');
                    Common.DataTableCustom.RefreshTableData('metaDataTable');
                }, 800);
            }
        };

        conn.on('ReceiveDiffProgress', progressHandler);

        $.ajax({
            url: `/ScriptMetaData/RefreshAllDiffs?connectionId=${encodeURIComponent(connectionId)}`,
            type: 'POST'
        })
        .fail(function () {
            hideOverlay();
            Notifications.GetNotification('Greška pri osvježavanju razlika', 'danger');
        })
        .always(function () {
            conn.off('ReceiveDiffProgress', progressHandler);
        });
    }
}